import { useSelector } from 'react-redux';
import { State } from 'store/types';

export const useSnsEnabled = () => {
  const snsData = useSelector((state: State) => state.snsConfig.data);
  return !!snsData;
};
